import React, { useEffect, useRef, useState } from "react";
import api from "../../seller-apis/api";
import '../order.css';
import { useAlert } from "react-alert";
// approved Product opp added
import { approvedProductsOpp } from '../../seller-apis/apidataField';
import PaginationNew from "../common/Pagination";
import servicesApi from '../../seller-apis/servicesApi';
import Popup from '../common/Popup';
import UpdtProPopup2 from '../common/UpdtProPopup2';
import { updateProductStatusSingle } from "../../Actions/ProductDetail/Single";
import { Form, Modal } from "react-bootstrap";
import ConfirmationModal from "../common/ConfirmationModal";
import { useDispatch } from "react-redux";
import MatchPriceModal from "../common/MatchPriceModal";
import OrderSKUSearch from "../common/ProductSearch/OrderSKUSearch";
import { Actions } from "../../Actions/Actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
//SL-698
import PriceComparisonTable from "../common/PriceComparisonTable.js";
import { saveVendorStock } from "../../services/vendor.service.js";
import MainLoader from "../common/Loader/PageLoader.js";

var globalFilterData = {
  "pageNo": 1,
};


//set SearchParam 
const searchParam = {
  /*"vendors.vActive": { 
    "$exists": true, 
    "$ne": "REJECT" 
  }, 
  "vendors.active": true, 
  "$or": [
    { "vendors.vActive": "INACTIVE" }, 
    { "vendors.combination.vActive": "INACTIVE" }
  ], 
  "$and": [
    { "vendors.prSts": { "$exists": true } }, 
    { "vendors.prSts": { "$ne": "V_PENDING" } }
  ]*/
};
function OutOfStockOpportunity() {
  const alert = useAlert();
  const [tickets, setTickets] = useState([]);
  var currentDate = new Date();
  // Get the date before 15 days
  var before15Days = new Date();
  before15Days.setDate(currentDate.getDate() - 30);

  // Format the dates as strings (optional)
  var currentDateStr = currentDate.toISOString().split("T")[0];
  var before15DaysStr = before15Days.toISOString().split("T")[0];
  const [sortdatefrom, setsortdatefrom] = useState(before15DaysStr);
  const [sortdateto, setsortdateto] = useState(currentDateStr);
  const [totalRcord, setTotalReord] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [cbimg, setcbimg] = useState();
  const [selectedProductPopup, setselectedProductPopup] = useState();
  const [updtProVisibility, setupdtProVisibility] = useState(false);
  const [clickedUpdateNo, setclickedUpdateNo] = useState();
  const [updtPopuprel, setupdtPopuprel] = useState([]);
  const [otherSellerPrice, setotherSellerPrice] = useState();
  const [confirmationState, setconfirmationState] = useState(false);
  const [selectedObject, setSelectedObject] = useState();
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [matchObject, setMatchObject] = useState(false);
  const [searchPro, setsearchPro] = useState();
  const [searchType, setSearchType] = useState("Product Name");
  const [selectedUrls, setSelectedUrls] = useState({});
  const [backInStockState, setBackInStockState] = useState({});
  const [prSts, setPrSts] = useState({})
  const [modify, setModify] = useState(false)
  const [penddingData, setPenddingData] = useState(false)
  const [priceState, setPriceState] = useState({});
  const [skuState, setSKUState] = useState({});//SL-735
  const [ennewloader, setennewloader] = useState("none");
  const outerdivRef = useRef(null);
  const loaderDivRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  //SL-675
  const [totalRcordId, setTotalReordId] = useState([]);

  // l1-2341 (18-9-25)
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [selectedCombination, setSelectedCombination] = useState(null);
  /**
   * Show Loading
   */
  function applyLoader() {
    if (loaderDivRef.current && outerdivRef.current) {
      loaderDivRef.current.classList.add("loader-bt");
      setennewloader("flex");
      outerdivRef.current.classList.add("div-bk");
    }
  }
  /**
   * Hide Loading
   */
  function removeLoader() {
    if (loaderDivRef.current && outerdivRef.current) {
      setennewloader("none");
      loaderDivRef.current.classList.remove("loader-bt");
      outerdivRef.current.classList.remove("div-bk");
    }
  }

  useEffect(() => {
    if (window.location.hash === '#popupDetail') {
      history.replace(window.location.pathname); // Replace the current URL
    }
    getOpportunity(globalFilterData)
  }, []);

  const getOpportunity = (filterData = globalFilterData) => {
    applyLoader()
    //SL-675
    filterData["productId"] = totalRcordId.length == 0 ? true : false;
    //set fetchOutOfStockOpportunity api and set approvedProductsOpp new data
    api.Opportunity.fetchOutOfStockOpportunity(approvedProductsOpp(filterData)).then(res => {
      setTotalReord(res.totalRecords);
      setTickets(res.data);
      if (totalRcordId.length == 0) {//SL-675
        setTotalReordId(res?.productId);
        filterData["productId"] = false;
      }
      //Actions.OpportunityOutOfStockCountAction(dispatch, res.totalRecords);
      removeLoader()
    });
  };

  /**
   * Handle Pagination
   * @param {*} data 
   */
  function paginate(data) {
    setCurrentPage(data.number);
    let filter = globalFilterData;
    filter['pageNo'] = data.number;
    getOpportunity(filter);
  }


  //refresh productpopup
  const params = window.location.hash
  useEffect(() => {

    if (params) {
      const url = localStorage.getItem("productUrl")
      const price = localStorage.getItem("productPrice")
      let data =
      {
        "filter": { "urlKey": url }
      }
      servicesApi.getProductDetail(data).then((res) => {
        detail([res.data], price)

        setpopupVisibilityDetail("2");
      }).catch(err => console.log(err))
    }

  }, [params])

  // For detail of product
  const detailnew = (url, price) => {
    //setlocalstorage
    localStorage.setItem("productUrl", url)
    localStorage.setItem("productPrice", price)

    let data =
    {
      "filter": { "urlKey": url }
    }
    servicesApi.getProductDetail(data).then((res) => {
      detail([res.data], price)

      setpopupVisibilityDetail("2");
    }).catch(err => console.log(err))

  }

  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [detailPPrice, setdetailPPrice] = useState("");
  // Popup showing detail
  function detail(data, price) {
    setdetailPPrice(price)

    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }

  //Popup related functions
  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }

  // Check response of product added
  function callbackResponse(msg) {
    if (msg === "product added" || msg === "product updated") {
      setupdtProVisibility(false);
      alert.success("Product Added Successfully");
      getOpportunity(globalFilterData);
    }
    else {
      setupdtProVisibility(false)
      alert.error("Product not added")
    }
  }

  function checkpopupvisibility(e) {
    if (e === false) {
      setupdtProVisibility(false)
    }
    else {
      setupdtProVisibility(true)
    }
  }

  async function responseconfirmation(ans, productId, stock, from, combination, prSts) {
    console.log(selectedObject)

    setconfirmationState(false);
    if (ans === "yes" && penddingData === false) {
      console.log("d")
      // l1-2341 (18-9-25)
      let stockStatus = (Number(stock) > 0) ? "In Stock" : "Out Of Stock"
      if (prSts === "V_PENDING") {
        setModify((prevState) => ({
          ...prevState,
          [productId]: true,
        }));
      } else {
        setModify((prevState) => ({
          ...prevState,
          [productId]: false,
        }));
      }
      let data;
      data = {
        _id: productId,
        vActive: "ACTIVE",
        stock: stock,
        url: combination, // set combination url
        reason: ""
      };
      //if given 0, then out of stock
      if (stock == 0) {
        data["vActive"] = "INACTIVE";
        data["reason"] = "Out Of Stock";
        await handleSaveVendorStock(stockStatus, stock);
      }
      else if (selectedTicket?.combination?.length > 0 && (Number(selectedCombination?.stock) < 1) && Number(stock) > 0) {
        await handleSaveVendorStock(stockStatus, stock);
      }
      else if((Number(selectedObject?.vendors?.[0]?.stock)<1 && Number(stock)>0) || !selectedObject?.vendor?.stock){
        await handleSaveVendorStock(stockStatus, stock);
      }


      //SL-903
      data['receivedFrom'] = "restock";
      updateProductStatusSingle(dispatch, data);
      setSelectedUrls({})
      setTimeout(() => {
        getOpportunity();
      }, 800);
    }
    else {
      console.log("3")
      setModify(true);
    }
  }

  function confirmationBoxHiding(state) {
    setconfirmationState(false);

  }

  const handleReStock = (pName, pId, Combination, prSts, ticket) => {
    console.log(ticket)
    setSelectedTicket(ticket)
    if (!Combination) {
      setBackInStockState((prevState) => ({
        ...prevState,
        [pId]: true,
      }));
    } else if (prSts === "V_PENDING") {
      let obj = {};
      obj['pName'] = pName;
      obj['pId'] = pId;
      obj['Combination'] = Combination
      obj['prSts'] = prSts;
      obj['vendors'] = ticket?.vendors
      setSelectedObject(obj)
      setconfirmationState(true);
      setPenddingData(true)
      setBackInStockState((prevState) => ({
        ...prevState,
        [pId]: false,
      }));
      setPrSts((prevState) => ({
        ...prevState, [pId]: "V_PENDING"
      }))
    } else {
      const dataurl = ""
      let obj = {};
      obj['pName'] = pName;
      obj['pId'] = pId;
      obj['Combination'] = Combination
      obj['prSts'] = prSts
        obj['vendors'] = ticket?.vendors
      setSelectedObject(obj)
      setconfirmationState(true);
      setBackInStockState((prevState) => ({
        ...prevState,
        [pId]: false,
      }));
    }
  }

  // l1-2341 (18-9-25)
  const handleSaveVendorStock = async (stockStatus, stockVal) => {
    try {
      console.log(selectedObject)
      let data = {
        "product": selectedTicket?._id,
        "vendor": localStorage.getItem("vendorId"),
        "taxClass": selectedTicket?.vendors?.[0]?.taxClass,
        "purchase_price": selectedTicket?.vendors?.[0]?.purchase_price,
        "stock": stockVal,
        "status": "AUTOAPPROVED",
        "stockStatus": stockStatus,
        "site_price": selectedTicket?.specialPrice ? selectedTicket?.specialPrice : selectedTicket?.price,
        "categories": selectedTicket?.categories,
        ...(selectedTicket?.combination?.url && { "combination.url": selectedUrls }),
        "receivedFrom":"seller"
      }
      console.log(data)
      const res = await saveVendorStock(data)
      //SL-1068
      if(res===true)
        alert.success("Record updated");
      
    } catch (err) {
      console.log(err)
      alert.error(err.message || "Failed to update stock status");
      // Re-throw the error so the calling function knows it failed
      throw err;
    }
  }

  const getPriceMatchObject = (data) => {

    setShowMatchModal(true);
    setMatchObject(data)
  }
  const closeMatchModal = () => {
    setShowMatchModal(false);

  }
  function changePrice(e, prd, index) {
    e.preventDefault();

    let l = []
    let newl = [];
    l = e.target.value.split(",")

    newl = l.map(item => parseInt(item))

    let nTickets = JSON.parse(JSON.stringify(tickets));
    nTickets[index].lowestPrice = l[2];


    setTickets(nTickets);

  }

  //set _id-objectId filed
  const filterSearch = (data) => {
    //setsearchPro(data.data);
    //setSearchType(data.type)
    globalFilterData['filters'] = { ...globalFilterData.filters, "_id-objectId": data.data }
    //Search Issue on Other than 1st Page SL-698 and SL-675
    if (globalFilterData?.searchIds)
      delete globalFilterData['searchIds'];
    globalFilterData.pageNo = 1;
    getOpportunity(globalFilterData);
    //SL-698
    if (globalFilterData?.filters && globalFilterData['filters']['_id-objectId'])
      delete globalFilterData['filters']['_id-objectId'];
  }

  const ApiCalling = () => {
    if (globalFilterData?.searchIds)
      delete globalFilterData['searchIds'];
    globalFilterData.pageNo = currentPage;
    getOpportunity(globalFilterData)
  }

  const handleSelectChange = (ticket, event) => {
    const selectedUrl = event.target.value;
    const prStsData = ticket?.vendors?.[0]?.combination?.find(item => item?.url === selectedUrl);
    const selCombination = ticket?.combination?.find(item => item?.url === selectedUrl);
    setSelectedUrls((prevState) => ({
      ...prevState,
      [ticket._id]: selectedUrl, // Update the URL for the specific ticket
    }));

    setBackInStockState((prevState) => ({
      ...prevState,
      [ticket._id]: !selectedUrl, // Disable button if no value is selected
    }));

    setPrSts((prevState) => ({
      ...prevState,
      [ticket._id]: prStsData?.prSts
    }))

    setModify(prevState => ({
      ...prevState,
      [ticket._id]: prStsData?.prSts === "V_PENDING",
    }));

    //set price state
    setPriceState((prevState) => ({
      ...prevState,
      [ticket._id]: prStsData?.purchase_price,
    }));

    //set sku state
    setSKUState((prevState) => ({
      ...prevState,
      [ticket._id]: selCombination?.SKU,
    }));
    setSelectedCombination(selCombination)
    console.log('prStsData', prStsData)
  };

  /**
  * Search By Keyword On Enter
  */
  const searchByKeyword = (value, type, productIds) => {

    if (productIds.length > 0) {
      setsearchPro(productIds);
      setSearchType(type)
      globalFilterData['searchIds'] = productIds
      //Search Issue on Other than 1st Page SL-698 and SL-675
      globalFilterData.pageNo = 1;
      setCurrentPage(1);
      getOpportunity(globalFilterData);

    }
    else {
      setTotalReord(0);
      setTickets([]);
    }
  }

  return (
    <div>
      <div className="table-responsive">
        <table className="ord_table new-table-design" style={{ "width": "100%" }}>
          <thead>
            <tr>
              <th style={{ width: '10%' }}>
                Product Image
              </th>
              <th style={{ width: '40%' }}>
                Product Details
                <div className='topprodsearch flex-column'>
                  <OrderSKUSearch
                    filterSearch={filterSearch}
                    searchNewEnq={setsearchPro}
                    searchParam={searchParam}
                    from={"orders"}
                    flag="Opportunity" // set flag
                    apiCall={ApiCalling}
                    data="filedData"
                    totalRcordId={totalRcordId}
                    searchByKeyword={searchByKeyword}
                  />
                </div>
              </th>
              <th style={{ width: '30%' }}>Current Transfer<br />Price<br /><span style={{ color: 'grey' }}>(Incl. GST)</span></th>
              <th style={{ width: '20%' }}>Actions</th>
            </tr>
          </thead>
          <tbody id="orDeskContain" ref={outerdivRef}>
            {tickets?.length > 0 && tickets?.map((ticket, index) => {
              let baseImg;
              ticket.images.map((item) => {
                if (item.baseImage === true) {
                  if (item.image.startsWith("products")) {
                    baseImg = item.image;
                  }
                  else {
                    let img = item.image.substr("41")
                    baseImg = img;
                  }
                }
              })

              if (ticket.combination) {
                if (ticket.vendors?.[0].combination.length > 0) {
                  var combarry = [];
                  var singleAttr = true;

                  // Check if multiple attributes exist
                  if (ticket.combination[0]?.value?.length > 1) {
                    singleAttr = false;
                  }

                  // Process vendor and product combinations
                  ticket.vendors[0].combination.forEach((vitem) => {
                    ticket.combination.forEach((pitem) => {
                      if (
                        pitem.url === vitem.url &&
                        vitem.vActive === "INACTIVE"
                      ) {
                        let combinationObject;

                        if (!singleAttr) {
                          const com = pitem.value
                            .map((aitem, aindex) => `${aitem}${aindex !== pitem.value.length - 1 ? " x " : ""}`)
                            .join("");

                          combinationObject = {
                            com,
                            price: vitem.purchase_price,
                            lowestPrice: pitem.lowestPrice,
                            status: "Out of Stock", // Since vActive is INACTIVE
                            url: vitem.url,
                            inventoryStock: pitem.inventoryStock,
                          };
                        } else {
                          combinationObject = {
                            com: pitem.value[0],
                            price: vitem.purchase_price,
                            lowestPrice: pitem.lowestPrice,
                            status: "Out of Stock", // Since vActive is INACTIVE
                            url: vitem.url,
                            inventoryStock: pitem.inventoryStock,

                          };
                        }

                        combarry.push(combinationObject);
                      }
                    });
                  });
                }
              }


              if (ticket.combination) {
                if (ticket.vendors?.[0].combination.length > 0) {
                  var combarry = [];
                  var singleAttr = true;

                  // Check if multiple attributes exist
                  if (ticket.combination[0]?.value?.length > 1) {
                    singleAttr = false;
                  }

                  // Process vendor and product combinations
                  ticket.vendors?.[0].combination.forEach((vitem) => {
                    ticket.combination.forEach((pitem) => {
                      if (
                        pitem.url === vitem.url &&
                        vitem.vActive === "INACTIVE"
                      ) {
                        let combinationObject;

                        if (!singleAttr) {
                          const com = pitem.value
                            .map((aitem, aindex) => `${aitem}${aindex !== pitem.value.length - 1 ? " x " : ""}`)
                            .join("");

                          combinationObject = {
                            com,
                            price: vitem.purchase_price,
                            lowestPrice: pitem.lowestPrice,
                            status: "Out of Stock", // Since vActive is INACTIVE
                            url: vitem.url,
                            inventoryStock: pitem.inventoryStock,
                          };
                        } else {
                          combinationObject = {
                            com: pitem.value[0],
                            price: vitem.purchase_price,
                            lowestPrice: pitem.lowestPrice,
                            status: "Out of Stock", // Since vActive is INACTIVE
                            url: vitem.url,
                            inventoryStock: pitem.inventoryStock,

                          };
                        }
                        combarry.push(combinationObject);
                      }
                    });
                  });
                }
              }
              return (
                <tr>
                  {/* Image */}
                  <td className="td-img-cntn">
                    <div className='border-x'>
                      <img src={"https://s3.toolsvilla.com/" + baseImg} alt="img" className="px-2 product-i mx-1" />
                    </div>
                  </td>
                  {/* Product Details */}
                  <td className='fs-13 order_table_pname_cntn'>
                    <div className='border-x inline-initial'>
                      <a href='#popupDetail' onClick={() => detailnew(ticket.urlKey, ticket?.productId?.price)} className='prod-name'>{ticket.productName}</a>
                      <div className='order_table_sku'>
                        SKU:- {Array.isArray(ticket.combination) && ticket.combination.length > 0 && skuState[ticket._id] ? skuState[ticket._id] : ticket.SKU}
                        {/*ticket?.vendors?.combination?.value ? ticket?.vendors?.combination?.SKU : ticket.SKU*/}
                      </div>
                      {combarry?.length > 0 ?
                        <p className="invent_table_sku mt-2 mb-2 w-50">Combination's added : <Form.Select size="sm" className="pro_card_comb_box_invent" value={selectedUrls[ticket._id] || ""} onChange={(event) => handleSelectChange(ticket, event)}>
                          <option value="">Select Combination</option>
                          {combarry?.length > 0 && combarry.map((item, index1) => {
                            return (
                              <option key={index1} value={item?.url}>{item.com}</option>
                            )
                          })}
                        </Form.Select></p> : ""
                      }
                      {modify[ticket._id] ?
                        <span className="fw-bold text-danger mb-2">Price request pending. Please click on modify button to accept it.</span>
                        :
                        selectedUrls[ticket._id] && !priceState[ticket._id] ?
                          <span className="fw-bold text-danger mb-2">Price request pending. Please click on modify button to accept it.</span>
                          : ""
                      }
                      <a href='#popupDetail' onClick={() => detailnew(ticket.urlKey, ticket?.productId?.price)} className='detail-but'>
                        <button className='px-1 order_table_btn_details'>View Details</button>
                      </a>
                    </div>
                  </td>
                  {/* Current Price */}
                  <td>
                    <div className='border-x'>
                      {(combarry?.length > 0 && !selectedUrls[ticket._id]) || !ticket?.urlKey ? <span className="fw-bold text-danger mb-2">Select the Combination.</span>
                        : combarry?.length > 0 ?
                          priceState[ticket._id] ?
                            <div className='prod-price black-color' style={{ marginBottom: '10px' }}>
                              <i class="fa fa-inr" aria-hidden="true"></i>
                              {Array.isArray(ticket.combination) && ticket.combination.length > 0 ? Math.floor(priceState[ticket._id]) : Math.floor(ticket.vendors[0].purchase_price)}
                            </div> : ""
                          :
                          <div className='prod-price black-color' style={{ marginBottom: '10px' }}>
                            <i class="fa fa-inr" aria-hidden="true"></i>
                            {Math.floor(ticket.vendors[0].purchase_price)}
                          </div>
                      }
                      {Array.isArray(ticket?.combination) && ticket?.combination.length == 0 && (
                        <PriceComparisonTable mProduct={ticket} getPriceMatchObject={getPriceMatchObject} />
                      )}
                    </div>
                  </td>
                  {/* Actions */}
                  <td>
                    <div className='border-x'>
                      {modify[ticket._id] ? <div className="d-flex action_btn_cntn_invent">
                        <button className={`mt-1 invent_pro_modify`} onClick={() => window.open(`/productDetConf/${ticket?._id}?url=${selectedUrls[ticket._id]}`, "_blank")}><img src={`/edit-icon.webp`} /> Modify</button>
                      </div> : selectedUrls[ticket._id] && !priceState[ticket._id] ? <button className={`mt-1 invent_pro_modify`} onClick={() => window.open(`/productDetConf/${ticket?._id}?url=${selectedUrls[ticket._id]}`, "_blank")}><img src={`/edit-icon.webp`} /> Modify</button> :
                        <button className={`p-1 ${(combarry?.length > 0 && !selectedUrls[ticket._id]) || !ticket?.urlKey ? "order_table_btn_details2" : "order_table_btn_details"}`} onClick={() => handleReStock(ticket.productName, ticket?._id, selectedUrls[ticket._id] ? selectedUrls[ticket._id] : ticket?.urlKey, prSts[ticket._id], ticket)} disabled={combarry?.length > 0 ? !selectedUrls[ticket._id] : !ticket?.urlKey}>Back in stock</button>
                      }

                    </div>
                  </td>
                </tr>
              );
            })}
            {tickets.length === 0 && (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', padding: '1rem' }}>
                  No record found!
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <PaginationNew
        number={totalRcord}
        paginate={paginate}
        activ={currentPage}
        comp={"support"}
        size={20} // set by defult add page size
      />

      <div class="d-flex justify-content-center" id="enNewLoader" ref={loaderDivRef}>
        <div
          style={{ display: ennewloader }}
        >
         <MainLoader/>
        </div>
      </div>

      <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
        <Popup
          from="outOfStockOpportunity"
          description={productDetail[0].description}
          sdescription={productDetail[0].shortDescription}
          descriptionNew={productDetail[0].descriptionNew}
          specificationNew={productDetail[0].specificationNew}
          name={productDetail[0].productName}
          price={detailPPrice}
          pkgs={productDetail[0]?.pkgs}
          manufacturerName={productDetail[0]?.manufacturerName}
          SKU={productDetail[0]?.SKU}
          popupVisibility={setpopupVisibilityDetail}
          images={productDetail[0].images}
          videos={productDetail[0].videos}
          hideTransferPrice={true}
        />
      </div>

      {updtProVisibility === true ?
        <UpdtProPopup2
          lead={clickedUpdateNo}
          productName={selectedProductPopup}
          Popupvisible="block"
          img={cbimg}
          detail={updtPopuprel}
          lowestPrice={otherSellerPrice}
          Popupvisibilityfun={checkpopupvisibility}
          from="chooseProduct"
          callbackResFun={callbackResponse}
        /> : <></>
      }
      <Modal
        show={confirmationState}
        size="lg"

        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ConfirmationModal
          onHide={confirmationBoxHiding}
          pId={selectedObject?.pName}
          selectedId={selectedObject?.pId}
          msg={`Are you sure you want to make this product "In Stock" ?`}
          proresDeact={false}
          responseconfirmationFun={responseconfirmation}
          buttonDesign={true}
          combination={selectedObject?.Combination} // set combination
          prSts={selectedObject?.prSts}
          from="opportunity"
        />
      </Modal>
      {showMatchModal &&
        <MatchPriceModal
          otherPrice={matchObject?.lowestPrice}
          getProducts={getOpportunity}
          show={showMatchModal}
          SKU={matchObject?.SKU}
          url={matchObject?.url}
          productId={matchObject?.productId}
          handleClose={closeMatchModal}
          receivedFrom="Restock Opp"
        />
      }
    </div>
  );
}

export default OutOfStockOpportunity;
